import React, { useState } from "react";
import { Link } from "react-router-dom";

const OrderTrack = () => {
  const [orderInput, setOrderInput] = useState("");
  const [status, setStatus] = useState(null);
  const [error, setError] = useState("");

  const handleTrack = (e) => {
    e.preventDefault();
    setError("");
    setStatus(null);

    const pattern = /^#[0-9]{5}$/;

    if (!pattern.test(orderInput.trim())) {
      setError("Please enter a valid order ID (e.g., #12345).");
      return;
    }

    const statuses = [
      "Order Placed",
      "Processing",
      "Packed & Awaiting Shipment",
      "Shipped",
      "Out for Delivery",
    ];

    const selected = statuses[Math.floor(Math.random() * statuses.length)];

    setTimeout(() => {
      setStatus({
        id: orderInput.trim(),
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
        status: selected,
      });
    }, 800);
  };

  return (
    <section
      style={{ minHeight: "78vh", background: "#f6f7fb", padding: "60px 0" }}
    >
      <div className="container" style={{ maxWidth: "620px" }}>
        {/* Title */}
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h2 style={{ fontWeight: 700, fontSize: "30px" }}>
            Track Your Order
          </h2>
          <p style={{ color: "#666" }}>
            Enter your order ID to check the latest status.
          </p>
        </div>

        {/* Card */}
        <div
          style={{
            background: "#fff",
            padding: "35px",
            borderRadius: "14px",
            boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                background: "#007bff15",
                width: "45px",
                height: "45px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "12px",
              }}
            >
              <i
                className="ph ph-magnifying-glass"
                style={{ fontSize: "22px", color: "#007bff" }}
              ></i>
            </div>
            <h5 style={{ margin: 0, fontWeight: 600 }}>Order Lookup</h5>
          </div>

          {/* Form */}
          <form onSubmit={handleTrack} style={{ display: "flex", gap: "10px" }}>
            <input
              type="text"
              value={orderInput}
              onChange={(e) => setOrderInput(e.target.value)}
              placeholder="e.g., #12345"
              style={{
                flex: 1,
                border: "1px solid #ddd",
                padding: "12px 14px",
                borderRadius: "10px",
                fontSize: "15px",
              }}
            />
            <button
              type="submit"
              style={{
                background: "#111",
                color: "white",
                padding: "12px 20px",
                borderRadius: "10px",
                fontWeight: "600",
                border: "none",
                cursor: "pointer",
              }}
            >
              Track
            </button>
          </form>

          {error && (
            <p style={{ color: "red", marginTop: "10px", fontWeight: 500 }}>
              {error}
            </p>
          )}

          <p style={{ fontSize: "14px", color: "#777", marginTop: "12px" }}>
            *You can find your order number in your confirmation email.
          </p>

          {/* Status Result */}
          {status && (
            <div
              style={{
                marginTop: "30px",
                padding: "20px",
                borderRadius: "12px",
                background: "#fafafa",
                border: "1px solid #eee",
              }}
            >
              <p style={{ margin: 0, fontWeight: 600 }}>
                Order <span style={{ color: "#007bff" }}>{status.id}</span>
              </p>

              <div
                style={{ marginTop: "10px", fontSize: "15px", color: "#444" }}
              >
                <p>
                  <strong>Status:</strong> {status.status}
                </p>
                <p>
                  <strong>Last Updated:</strong> {status.date} at {status.time}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Back Button */}
        <div style={{ textAlign: "center", marginTop: "25px" }}>
          <Link
            to="/"
            style={{
              color: "#007bff",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OrderTrack;
